import React, { useState, useEffect } from 'react'

export const ProtectedComponent = ({ children, user, author, onlyAuth }) => {
    const [accessGranted, setAccessGranted] = useState(false)

    useEffect(() => {
        const role = user?.user?.roles[0].name
        const userId = user?.user?.id
        if (role === 'admin' || role === 'moderator') setAccessGranted(true)
        else if (author && author === userId) setAccessGranted(true)
        else if (onlyAuth && role) setAccessGranted(true)
        else setAccessGranted(false)
    }, [user, author])

    return accessGranted ? children : null
}